module.exports = __webpack_public_path__ + "media/images/header_icons/file-a9abc5c5c8990ee233ee445b158f807f.svg";